// =========== plugin import ============= //
import React, { useEffect, useState } from 'react'
import axios from 'axios'
// =========== component import ============ //
import { PageTitle } from '../../../../_template/layout/core/PageData';
import DevProfileSkeleton from './component/DevProfileSkeleton';
import DevProfileData from './component/DevProfileData';
import DevProfileUpdateForm from './component/DevProfileUpdateForm';

const DevProfile = () => {
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const pageTitle = [
        {
            title: 'Agents',
            path: '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    // -------- define all state here ------- //
    const [isUpdate, setIsUpdate] = useState(false);
    const [profileData, setProfileData] = useState({});

    const getDevProfileData = async () => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'D') {
            apiToken = localStorage.getItem('developertoken')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        const api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}developer/get-dev-profile-data`, {}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const _devData = res.data.data.devProfileData[0];
                setProfileData(_devData)
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    useEffect(() => {
        getDevProfileData();
    },[]);

    const updatedProfileData = (updatedData) => {
        setProfileData(prev => ({
            ...prev,
            user_full_name: updatedData.full_name
        }));
        if(updatedData.new_password !== ''){
            setProfileData(prev => ({
                ...prev,
                password: btoa(updatedData.new_password)
            }));
        }
    }

    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>Profile</PageTitle>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="card mb-5 mb-xl-10">
                        <div className="card-header">
                            <div className="card-title m-0">
                                <h3 className="fw-bold m-0 fs-2x">
                                    {
                                        !isUpdate &&
                                        `Profile Details`
                                    }
                                    {
                                        isUpdate &&
                                        `Update Profile`
                                    }
                                </h3>
                            </div>
                            {
                                !isUpdate &&
                                <div
                                    className="btn btn-sm btn-primary align-self-center" 
                                    onClick={() => setIsUpdate(true)}>
                                    Edit Profile
                                </div>
                            }
                        </div>
                        <div className="card-body p-9">
                            {
                                isUpdate ? (
                                    <DevProfileUpdateForm 
                                        setIsUpdate={setIsUpdate}
                                        profileData={profileData}
                                        profileFormData={updatedProfileData}
                                    />
                                ) : Object.keys(profileData).length === 0 ? (
                                    <DevProfileSkeleton />
                                ) : (
                                    <DevProfileData profileData={profileData} />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DevProfile